import { Link } from "react-router-dom";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const LinkifiedText = ({ text }) => {
  const parts = text.split(/(\[\[[^\]|]+\|[^\]]+\]\])/g);
  return parts.map((part, i) => {
    const match = part.match(/^\[\[([^\]|]+)\|([^\]]+)\]\]$/);
    if (!match) return <span key={i}>{part}</span>;
    return (
      <Link
        key={i}
        to={match[1]}
        className="font-semibold text-terracotta-deep underline decoration-terracotta/40 underline-offset-4 hover:decoration-terracotta"
      >
        {match[2]}
      </Link>
    );
  });
};

export const FaqAccordion = ({ items, testidPrefix = "faq" }) => (
  <Accordion type="single" collapsible className="w-full space-y-4">
    {items.map((item, i) => (
      <AccordionItem
        key={i}
        value={`item-${i}`}
        className="rounded-2xl border border-ink/5 bg-white px-6 md:px-8 shadow-[0_10px_30px_-12px_rgba(17,14,13,0.06)]"
      >
        <AccordionTrigger
          data-testid={`${testidPrefix}-question-${i}`}
          className="py-6 text-left font-display text-base md:text-lg font-semibold tracking-tight hover:no-underline hover:text-terracotta-deep transition-colors duration-300"
        >
          {item.q}
        </AccordionTrigger>
        <AccordionContent className="pb-6 text-sm md:text-base leading-relaxed text-plum/85">
          {item.a.split("\n").filter(Boolean).map((para, j) => (
            <p key={j} className="mb-3 last:mb-0"><LinkifiedText text={para} /></p>
          ))}
        </AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);
